
import { availableLocales } from 'bits/locale'
import { Action, Component, State, Vue } from 'bits/vue'

@Component({})
export default class LocaleSelector extends Vue {
  @State currentLocale
  @Action changeLocale
  locales = availableLocales

  emitChange(e: Event): void {
    this.changeLocale(e)
  }
}
